const integerFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
});

export const formatNumber = (value: number | null | undefined): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return '';
  }
  return integerFormatter.format(value);
};
